export const USER_API_BASE =
  process.env.NEXT_PUBLIC_USER_API_BASE ?? "http://20.219.111.203:8084";

export const AUTH_API_BASE =
  process.env.NEXT_PUBLIC_AUTH_API_BASE ?? "http://20.219.111.203:8085";

export const LMS_API_BASE =
  process.env.NEXT_PUBLIC_LMS_API_BASE ?? "http://20.219.111.203:8091";

export const SKILL_PRACTICE_API_BASE =
  process.env.NEXT_PUBLIC_SKILL_PRACTICE_API_BASE ?? "http://20.219.111.203:8097";

export const SYSTEM_PARAMS_API_BASE =
  process.env.NEXT_PUBLIC_SYSTEM_PARAMS_API_BASE ?? "http://20.219.111.203:8081";

// LMS Enterprise domain (Enterprise, Enterprise Member, Department, Team,
// Role Assignment, Member Assignment, Reporting Relation, Content Access).
export const ENTERPRISE_API_BASE =
  process.env.NEXT_PUBLIC_ENTERPRISE_API_BASE ?? "http://20.219.111.203:8094";

// Profile Types + Permissions (real Roles) — used to set up the "Company
// Admin" Profile Type/Role for FARE.
export const PROFILE_API_BASE =
  process.env.NEXT_PUBLIC_PROFILE_API_BASE ?? "http://20.219.111.203:8087";

// Assessment Builder — Assessments, Question Banks, Questions.
export const ASSESSMENT_API_BASE =
  process.env.NEXT_PUBLIC_ASSESSMENT_API_BASE ?? "http://20.219.111.203:8095";

// LMS Domain id — used ONLY to scope Category/SubCategory lookups for the
// Course create form (lib/lms/categories-api.ts `domainId` query param).
// Despite the name, this is a Domain id, not FARE's real Application id —
// it predates FARE_APPLICATION_ID below and is kept only for that one
// Category/SubCategory usage, which expects this exact value.
export const APPLICATION_ID =
  process.env.NEXT_PUBLIC_APPLICATION_ID ?? "6a8c0f1c87c0da7dcf06aef4";

// FARE's real Application id — the "Applications" system-param entry with
// type "FARE" (GET :8081/system-params?domainType=Applications), verified
// live. This is what real records actually carry as their `applicationId`
// field — use this (not APPLICATION_ID above) for anything genuinely
// scoped by Application id: Courses (lib/lms/api.ts), Profile Types
// (lib/lms/enterprise-api.ts), Directories (lib/lms/directories-api.ts),
// and any future FARE-scoped resource.
export const FARE_APPLICATION_ID =
  process.env.NEXT_PUBLIC_FARE_APPLICATION_ID ?? "6a8c0516b9dc682543abbc4e";
